import React, { useState, useEffect } from'react';
import { useNavigate } from'react-router-dom';
import Navbar from'./Navbar';
import BottomTabBar from'./BottomTabBar';
import Profile from'./Profile';
import UDsidebar from'../common/UDsidebar';
import ConfirmationModal from'../common/ConfirmationModal';
import { useAuth } from'../../context/AuthContext';

const ProfilePage = () => {
 const { user, logout } = useAuth();
 const navigate = useNavigate();
 const [showSidebar, setShowSidebar] = useState(false);
 const [showLogoutConfirm, setShowLogoutConfirm] = useState(false);
 const [isWebView, setIsWebView] = useState(false);

 useEffect(() => {
 if (typeof window ==='undefined') return;
 const ua = navigator.userAgent ||'';
 const isAndroidWebView = /\bwv\b|; wv\)/i.test(ua);
 const isIosWebView =
 /iPad|iPhone|iPod/i.test(ua) && /AppleWebKit/i.test(ua) && !/Safari/i.test(ua);
 const isEmbeddedAppWebView = Boolean(
 window.ReactNativeWebView || window.flutter_inappwebview || window.webkit?.messageHandlers
 );
 const previewParams = new URLSearchParams(window.location.search);
 const forceWebViewPreview =
 previewParams.get('webview') ==='1'||
 previewParams.get('preview') ==='webview'||
 previewParams.get('app') ==='1';
 setIsWebView(
 isAndroidWebView || isIosWebView || isEmbeddedAppWebView || forceWebViewPreview
 );
 }, []);

 const handleHome = () => {
 navigate('/dashboard');
 };

 const handleLogout = () => {
 setShowLogoutConfirm(true);
 };

 const confirmLogout = () => {
 setShowLogoutConfirm(false);
 logout();
 navigate('/');
 };

 const cancelLogout = () => {
 setShowLogoutConfirm(false);
 };

 const handleProfile = () => {
 navigate('/profile');
 };

 const handleRides = () => {
 navigate('/rides');
 };

 if (!user) {
 navigate('/');
 return null;
 }

 return (
 <div
 className={`min-h-screen bg-gray-50 pb-20 md:pb-0 relative ${isWebView ?'overflow-x-hidden':''}`}
 style={{ paddingBottom:'80px'}}
 >
 <div className="hidden md:block">
 <Navbar 
 onBecomeDriver={() => navigate('/driver/register')}
 onDriverDashboard={() => {
 if (user.driverId) {
 navigate('/driver/dashboard');
 } else {
 // Show driver registration popup or navigate
 navigate('/driver/register');
 }
 }}
 onHome={handleHome}
 onProfile={handleProfile}
 onRides={handleRides}
 onLogout={handleLogout}
 user={user}
 isDriver={!!user.driverId}
 onMenuClick={() => setShowSidebar(true)}
 />
 </div>
 
 {/* Sidebar - Mobile Only */}
 <UDsidebar
 isOpen={showSidebar}
 onClose={() => setShowSidebar(false)}
 user={user}
 isDriver={false}
 onHome={handleHome}
 onProfile={handleProfile}
 onRides={handleRides}
 onLogout={handleLogout}
 onBecomeDriver={() => navigate('/driver/register')}
 onDriverDashboard={() => {
 if (user.driverId) {
 navigate('/driver/dashboard');
 } else {
 navigate('/driver/register');
 }
 }}
 />
 
 <div className="pb-20 md:pb-0"style={{ paddingBottom:'80px'}}>
 <Profile user={user} onLogout={handleLogout} />
 </div>
 
 {/* Bottom Tab Bar - Always visible on mobile */}
 <BottomTabBar activeTab="profile"onTabChange={(tabId) => {
 if (tabId ==='home') navigate('/dashboard');
 else if (tabId ==='rides') navigate('/rides');
 else if (tabId ==='account') navigate('/dashboard');
 }} />

 {/* Logout Confirmation Modal */}
 <ConfirmationModal
 show={showLogoutConfirm}
 title="Logout"message="Are you sure you want to logout?"confirmText="Yes"cancelText="No"onConfirm={confirmLogout}
 onCancel={cancelLogout}
 confirmButtonClass="bg-red-600 hover:bg-red-700"/>
 </div>
 );
};

export default ProfilePage;

